/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable lingui/text-restrictions */

//import { DEFAULT_MAX_TOKENS, DEFAULT_MODEL } from "@/client/constants/llm";
//import { useOpenAiStore } from "@/client/stores/openai";
import { openai } from "./client";

const SYSTEM_PROMPT = `# Role: 简历优化专家
你是一位专业的简历优化专家，擅长根据内容类型提供针对性的简历优化建议。

# Task:
分析简历内容，识别内容类型，根据对应的格式标准优化文本。

# Output Format:
<ul>
<li>段落使用 <p> 标签</li>
<li>换行使用 <br> 标签</li>
<li>列表使用 <ul> 或 <ol> 和 <li> 标签</li>
<li>重点内容使用 <strong> 标签</li>
</ul>

# Content Type Analysis:
根据内容类型提供差异化优化：

1. **工作经历**
   - 使用 <ul><li> 标签列出职责/成果
   - 强调量化成果和关键贡献
   - 确保每条描述具体且有说服力

2. **项目经验**
   - 使用 <ul><li> 标签结构化项目信息
   - 包含项目描述、技术栈、职责和成果
   - 突出个人贡献和技术难点

3. **技能描述**
   - 使用 <ul><li> 标签列出技能点
   - 按相关性和熟练度排序
   - 添加具体应用场景

4. **自我评价**
   - 使用 <p> 标签包裹核心内容
   - 突出核心竞争力
   - 体现个人特色

5. **教育背景**
   - 使用 <p> 标签，专业名称用 <em> 标签
   - 强调与求职相关的学术成就

# Optimization Focus:

1. **技术类内容**
   - 技术栈和工具的准确性
   - 量化的性能指标
   - 技术难点和解决方案

2. **管理类内容**
   - 团队和业务规模
   - 管理成果和指标
   - 决策影响力

3. **个人总结类内容**
   - 突出核心竞争力
   - 强调可迁移能力
   - 体现个人特色

# Guidelines:
1. 保持原文核心信息不变
2. 使用行业标准术语增强专业性
3. 添加量化数据提升说服力
4. 突出个人贡献和价值
5. 确保输出内容格式规范

# Important Notes:
- 确保所有HTML标签正确闭合
- 直接返回优化后的文本，不要包含解释
- 优化内容应符合所在行业标准和最佳实践`;

const USER_PROMPT = `请识别以下简历内容的类型，然后按照对应的格式规范优化。直接返回优化后的文本，不要包含任何解释性文字。

原文: {input}`;

export const improveWriting = async (text: string) => {
  const result = await openai().chat.completions.create({
    messages: [
      { role: "system", content: SYSTEM_PROMPT },
      { role: "user", content: USER_PROMPT.replace("{input}", text) },
    ],
    model: "glm-4-flash",
    max_tokens: 2048,
    temperature: 0,
    n: 1,
  });

  if (result.choices.length === 0) {
    throw new Error(`OpenAI 没有返回任何内容。`);
  }

  let content = result.choices[0].message.content ?? text;

  // Remove code block markers if present
  if (content.includes("```")) {
    const matches = /```(?:html)?\s*([\S\s]*?)\s*```/.exec(content);
    content = matches?.[1] ?? content;
  }

  return content.trim();
};
